import { FC, Fragment } from 'react';
import { Tr } from '@utils';
import { PackageDeal } from '@services';
import { Box, Grid } from '@mui/material';
import { VoltaageModalDialog, IVoltaageModalDialogProps, StripedTableCell } from '@components/common';

export interface IPackageDealIncludedServicesDialogProps extends IVoltaageModalDialogProps {
	entity?: PackageDeal;
}

export const PackageDealIncludedServicesDialog: FC<IPackageDealIncludedServicesDialogProps> = ({ entity, ...props }) => {
	return (
		<VoltaageModalDialog
			title={<Tr.Portal path="package-deal.services-included" />}
			titleProps={{ sx: { justifyContent: 'center' } }}
			dividers
			{...props}
		>
			{entity?.services ? (
				<Box sx={{ paddingX: 10, paddinTop: 3, paddingBottom: 5 }}>
					<Grid container>
						{entity.services.map(({ id, name, description, summary }, i) => (
							<Fragment key={`service-${id}-${i}`}>
								<StripedTableCell title={<Tr.Portal path="package-deal.service-name" />} xs={4} greyBg={!!(i % 2)}>
									{name || '-'}
								</StripedTableCell>
								<StripedTableCell title={<Tr.Portal path="package-deal.service-summary" />} xs={4} greyBg={!!(i % 2)}>
									{summary || '-'}
								</StripedTableCell>
								<StripedTableCell title={<Tr.Portal path="package-deal.service-description" />} xs={4} greyBg={!!(i % 2)}>
									{description || '-'}
								</StripedTableCell>
							</Fragment>
						))}
					</Grid>
				</Box>
			) : null}
		</VoltaageModalDialog>
	);
};
